import DropDownListener from './dropdown-listener';
import DropdownManagerService from './dropdown-manager.service';

const angular = require('angular');

const deps = [
    DropDownListener,
    DropdownManagerService
];

export default angular
    .module('spsng.components.dropdown-manager', deps)
    .name;
